export default "__VITE_ASSET__af7affa4__"